import React, { useState } from 'react';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { PARKING_GAP } from './constants';

interface ParkingRowDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onGenerate: (count: number, orientation: 'horizontal' | 'vertical', gap: number) => void;
}

export function ParkingRowDialog({ open, onOpenChange, onGenerate }: ParkingRowDialogProps) {
  const [count, setCount] = useState(10);
  const [orientation, setOrientation] = useState<'horizontal' | 'vertical'>('horizontal');
  const [gap, setGap] = useState(PARKING_GAP);

  const handleGenerate = () => {
    onGenerate(count, orientation, gap);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>Add Parking Row</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div className="space-y-1.5">
            <Label className="text-xs">Number of Spaces</Label>
            <Input
              type="number"
              min={1}
              max={50}
              value={count}
              onChange={(e) => setCount(Math.max(1, Number(e.target.value) || 1))}
            />
          </div>

          <div className="space-y-1.5">
            <Label className="text-xs">Orientation</Label>
            <RadioGroup value={orientation} onValueChange={(v) => setOrientation(v as 'horizontal' | 'vertical')}>
              <div className="flex items-center gap-3">
                <div className="flex items-center gap-1.5">
                  <RadioGroupItem value="horizontal" id="h" />
                  <Label htmlFor="h" className="text-xs">Horizontal</Label>
                </div>
                <div className="flex items-center gap-1.5">
                  <RadioGroupItem value="vertical" id="v" />
                  <Label htmlFor="v" className="text-xs">Vertical</Label>
                </div>
              </div>
            </RadioGroup>
          </div>

          <div className="space-y-1.5">
            <Label className="text-xs">Gap (px)</Label>
            <Input
              type="number"
              min={0}
              max={100}
              value={gap}
              onChange={(e) => setGap(Math.max(0, Number(e.target.value) || 0))}
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" size="sm" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button size="sm" onClick={handleGenerate}>Generate {count} spaces</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
